import {
  ADD_ATTACHMENT_FILE,
  APPEND_ATTACHMENTS_TO_UPLOAD,
  REMOVE_ATTACHMENT_FILE,
  RESET,
  SET_ALL_COMPANY_USERS,
  SET_ALL_MESSAGES,
  SET_ALL_NOTIFICATIONS,
  SET_ATTACHED_FILES_EDITOR,
  SET_ATTACHMENT_FILES,
  SET_ATTACHMENTS_TO_UPLOAD,
  SET_IS_LOADING,
  SET_IS_PENDING,
  SET_IS_UPLOAD_FILE,
  SET_REFERENCE,
  SET_SOCKET_INSTANCE,
  SET_TO_EDIT_MESSAGE,
  SET_USER_ID,
  UPDATE_MESSAGE_FILE_LABELS,
  UPDATE_MESSAGE_LABELS,
} from "./collaboration.actionTypes";

const initialState = {
  socketInstance: null,
  reference: null,
  userId: null,
  isLoading: true,
  allMessages: [],
  attachedFilesEditor: [],
  allChatsNotifications: [],
  allCompanyUsers: [],
  toEditMessage: null,
  isUploadFile: false,
  isPending: false,
  attachmentFiles: {},
  attachmentsToUpload: [],
};

export default (namespace) =>
  (state = initialState, action) => {
    switch (action.type) {
      case `${namespace}${SET_SOCKET_INSTANCE}`: {
        return { ...state, socketInstance: action.payload };
      }

      case `${namespace}${SET_REFERENCE}`: {
        return { ...state, reference: action.payload };
      }

      case `${namespace}${SET_USER_ID}`: {
        return { ...state, userId: action.payload };
      }

      case `${namespace}${SET_IS_LOADING}`: {
        return { ...state, isLoading: action.payload };
      }

      case `${namespace}${SET_ALL_MESSAGES}`: {
        return { ...state, allMessages: action.payload };
      }

      case `${namespace}${SET_ATTACHED_FILES_EDITOR}`: {
        return { ...state, attachedFilesEditor: action.payload };
      }

      case `${namespace}${SET_ALL_NOTIFICATIONS}`: {
        return { ...state, allChatsNotifications: action.payload };
      }

      case `${namespace}${SET_ALL_COMPANY_USERS}`: {
        return { ...state, allCompanyUsers: action.payload };
      }

      case `${namespace}${SET_TO_EDIT_MESSAGE}`: {
        return { ...state, toEditMessage: action.payload };
      }

      case `${namespace}${SET_IS_UPLOAD_FILE}`: {
        return { ...state, isUploadFile: action.payload };
      }

      case `${namespace}${SET_IS_PENDING}`: {
        return { ...state, isPending: action.payload };
      }

      case `${namespace}${SET_ATTACHMENT_FILES}`: {
        return { ...state, attachmentFiles: action.payload };
      }

      case `${namespace}${ADD_ATTACHMENT_FILE}`: {
        const { fileId, fileEntry } = action.payload;
        return {
          ...state,
          attachmentFiles: { ...state.attachmentFiles, [fileId]: fileEntry },
        };
      }

      case `${namespace}${REMOVE_ATTACHMENT_FILE}`: {
        const { fileId } = action.payload;
        const newAttachmentFiles = { ...state.attachmentFiles };
        delete newAttachmentFiles[fileId];
        return { ...state, attachmentFiles: newAttachmentFiles };
      }

      case `${namespace}${UPDATE_MESSAGE_LABELS}`: {
        const { messageId, labels } = action.payload;
        return {
          ...state,
          allMessages: state.allMessages.map((message) =>
            message.id === messageId ? { ...message, collaborateLabels: labels } : message
          ),
        };
      }

      case `${namespace}${UPDATE_MESSAGE_FILE_LABELS}`: {
        const { messageId, fileId, labels } = action.payload;
        return {
          ...state,
          allMessages: state.allMessages.map((message) =>
            message.id === messageId
              ? {
                  ...message,
                  collaborateFileLabels: (() => {
                    const existingFileLabels = message.collaborateFileLabels || [];
                    const existingFileIndex = existingFileLabels.findIndex(
                      (fileData) => fileData.fileId === fileId
                    );

                    if (existingFileIndex >= 0) {
                      // Update existing file entry
                      const updatedFileLabels = [...existingFileLabels];
                      updatedFileLabels[existingFileIndex] = {
                        ...updatedFileLabels[existingFileIndex],
                        labels,
                      };
                      return updatedFileLabels;
                    }
                    // Create new file entry
                    return [...existingFileLabels, { fileId: fileId, fileName: "", labels }];
                  })(),
                }
              : message
          ),
        };
      }

      case `${namespace}${SET_ATTACHMENTS_TO_UPLOAD}`: {
        return { ...state, attachmentsToUpload: action.payload };
      }

      case `${namespace}${APPEND_ATTACHMENTS_TO_UPLOAD}`: {
        return {
          ...state,
          attachmentsToUpload: [...(state.attachmentsToUpload ?? []), ...(action.payload ?? [])],
        };
      }

      case `${namespace}${RESET}`: {
        return initialState;
      }

      default:
        return state;
    }
  };
